/**
 * The configuration file for the ci-build-yml-config.ts file upgrading to Angular 15.
 */

export const replaces = {
    'displayName: \'Use Node 12.18.3\'' : 'displayName: \'Use Node 16.14.0\'',
    'versionSpec: 12.18.3': 'versionSpec: 16.14.0',
    'displayName: \'npm install @angular/cli\'': 'displayName: \'npm install @angular/cli@15.2.9\'',
    'customCommand: \'install -g @angular/cli@11.2.13\'': 'customCommand: \'install -g @angular/cli@15.2.9\'',
    'displayName: \'npm install typescript\'': 'displayName: \'npm install typescript@4.8.2\'',
    'customCommand: \'install -g typescript@4.1.5\'': 'customCommand: \'install -g typescript@4.8.2\''
};
